module.exports = __webpack_public_path__ + "media/images/icons/outlined/idcard-f08d830479f8e4fa96b2cb6755283053.svg";